import { render, staticRenderFns } from "./CustomerForm4473New.vue?vue&type=template&id=e83953b2&scoped=true"
import script from "./CustomerForm4473New.vue?vue&type=script&lang=js"
export * from "./CustomerForm4473New.vue?vue&type=script&lang=js"
import style0 from "./CustomerForm4473New.vue?vue&type=style&index=0&id=e83953b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e83953b2",
  null
  
)

export default component.exports